import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  Item,
  LoadPanel,
  Scrolling,
  Toolbar,
  Lookup,
  StateStoring,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";
import { notifyMsg } from "../../common/notify";
import { contrType } from "./data";

export default function QuotationListDataGrid(props) {
  const { contrNo, quotationListGridRef, contractListGridRef } = props;

  const [quotationListDataSource, setQuotationListDataSource] = useState(null);

  useEffect(() => {
    if (contrNo) {
      setQuotationListDataSource(
        new CustomStore({
          key: "quotNo",
          load: async () => {
            try {
              const result = await axios.get(
                `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg/${contrNo}`
              );

              return result.data;
            } catch (error) {
              console.log(error);
            }
          },

          remove: async (key) => {
            const result = await axios.delete(
              `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg/${key}`
            );

            if (result.data) {
              if (result.data.status == "205") {
                contractListGridRef.current.instance.getDataSource().reload();
              } else {
                notifyMsg(result.data.message, "error");
              }
            }
          },
        })
      );
    }
  }, [contrNo]);

  const cellRender = (data) => {
    return (
      <div style={{ textDecoration: "underline" }}>{data.displayValue}</div>
    );
  };

  const onCellClick = (e) => {
    if (e.columnIndex === 0 && e.data) {
      axios
        .get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg/file/${e.data.quotNo}`,
          {
            responseType: "blob",
          }
        )
        .then((result) => {
          if (result.headers["content-disposition"]) {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement("a");
            link.href = url;

            let fileName = null;

            if (
              result.headers["content-disposition"].includes(
                `filename*=UTF-8''`
              )
            ) {
              fileName = decodeURI(
                result.headers["content-disposition"].split(
                  `filename*=UTF-8''`
                )[1]
              );
            } else {
              fileName = result.headers["content-disposition"]
                .split("=")[1]
                .replace(/"/g, "");
            }

            // const fileName = result.headers["content-disposition"]
            //   .split("=")[1]
            //   .replace(/"/g, "");

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          } else {
            console.log("[warning]");
          }
        });
    }
  };

  return (
    <DataGrid
      id="quotationListGrid"
      ref={quotationListGridRef}
      dataSource={quotationListDataSource}
      keyExpr="quotNo"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      width={"50%"}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      height={"100%"}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",
      }}
      hoverStateEnabled={true}
      onCellClick={onCellClick}
    >
      <Editing mode="form" allowDeleting={true} />

      <LoadPanel enabled={true} />
      <FilterRow visible={true} />
      <HeaderFilter visible={true} />
      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <StateStoring
        enabled={true}
        type="localStorage"
        storageKey={"ProjectSetup.ContractRegistraion.QuotationListDataGrid"}
      />

      <Column
        dataField={"fileName"}
        caption="File Name"
        width={260}
        cellRender={cellRender}
      />
      <Column
        dataField={"quotNo"}
        caption="Quotation No."
        dataType={"string"}
        alignment="center"
        width={155}
      />
      <Column
        dataField={"contrNo"}
        caption="Contract No."
        dataType={"string"}
        alignment="center"
        width={135}
      />
      <Column
        dataField={"contrType"}
        caption="Contract Type"
        dataType={"string"}
        alignment="center"
        width={140}
      >
        <Lookup dataSource={contrType} displayExpr="name" valueExpr={"id"} />
      </Column>
      <Column
        dataField={"effectiveDate"}
        caption="Effective Date"
        alignment="center"
        dataType="date"
        format={"yyyy-MM-dd"}
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
        width={140}
      />
      <Column
        dataField={"uploadDate"}
        caption="Upload Date"
        alignment={"center"}
        dataType="date"
        format={"yyyy-MM-dd"}
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
        width={140}
      />
      <Column
        dataField={"BDEmployeeName"}
        caption="BD Manager"
        alignment={"center"}
        dataType="string"
        width={160}
      />
      {/* <Column dataField={"resnCorr"} caption="Reason for Correction" /> */}

      <Toolbar>
        <Item location="before">
          <span style={{ fontWeight: 500, color: "#009688" }}>
            QUOTATION LIST{contrNo ? `: ${contrNo}` : ``}
          </span>
        </Item>
      </Toolbar>
    </DataGrid>
  );
}
